module.exports = __webpack_public_path__ + "static/the-visitors_acrylic-on-canvas_59x79.5in-2660e6e43c15f565edfee640f0f49a1b.jpg";